import { ReactElement, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { ButtonIcon } from 'components/general';
import { StateToggleIcon } from 'components/common/StateToggleIcon';
import { formatTranslation } from 'intl';
import { InspectionTemplateTranslationKeys } from 'intl/keys';
import { Color } from 'shared/utils/colors';
import {
  EntityState,
  getNextEntityState,
  isEntityStatePublished,
} from 'components/common/dataGrid/columnsFactory/types';
import { useInspectionStore } from 'store/inspection';

const toggleOnIconSx = { color: Color.black };
const toggleOffIconSx = { color: Color.iconGray };

const TEMPLATE_STATE_TOOLTIP_KEYS = {
  [EntityState.published]: InspectionTemplateTranslationKeys.stateActiveTooltip,
  [EntityState.archived]: InspectionTemplateTranslationKeys.stateArchivedTooltip,
} as const;

export function InspectionTemplateStateToggle(): ReactElement {
  const intl = useIntl();

  const state = useInspectionStore.use.inspectionTemplatesListState();
  const setState = useInspectionStore.use.setInspectionTemplatesListState();

  const isPublished = isEntityStatePublished(state);

  const handleClick = useCallback(() => {
    setState(getNextEntityState(state));
  }, [state, setState]);

  return (
    <ButtonIcon
      onClick={handleClick}
      title={formatTranslation(intl, TEMPLATE_STATE_TOOLTIP_KEYS[state])}
    >
      <StateToggleIcon
        isOn={isPublished}
        onIconSx={toggleOnIconSx}
        offIconSx={toggleOffIconSx}
      />
    </ButtonIcon>
  );
}